import { isIOS } from './index';
import { getSearchParam, setAppQuery } from './url';
// 新版Grounds
import { Grounds } from '@ifeng-fe/client_grounds';

// 判断是否在端内,开发环境置为true，便于开发
export const isClient = process.env.NODE_ENV === 'development' ? true : !!window.grounds;

// 是否在客户端内
export const isGrounds = !!window.grounds;

/**
 * @description 拉起端内登录
 */
export const userLogin = () => {
    if (isGrounds) {
        window.grounds.userLogin();
    }
};

/**
 * @description 客户端获取用户登陆状态
 * @returns {boolean} true: 已登陆 | false: 未登录
 */
export const userIsLogin = () => {
    return !!window?.grounds?.userIsLogin();
};

/**
 * @description 客户端关闭当前webview
 */
export const groundsClose = () => {
    if (isGrounds) {
        window.grounds.close();
    }
};

/**
 * @description 客户端打开分享托盘(弃用)
 */
export const openAppShare = ({
    url = `${window.location.origin}${window.location.pathname}`,
    title = '',
    desc = '',
    thumbnail = '',
    documentId = '',
}) => {
    if (isGrounds) {
        const appQueryUrl = setAppQuery(url);

        window.grounds.openShare(appQueryUrl, title, desc, thumbnail, documentId);
    }
};

/**
 * @description 客户端打开分享托盘（新版：分享JOSN传参）
 * title标题
 * shareurl 分享链接
 * desc 简介
 * ios用thumb /安卓用thumbnail 缩略图
 * documentId 文章id
 * type 文章类型
 */
export const newShare = params => {
    const appQueryUrl = setAppQuery(params.url);

    if (isGrounds) {
        const paramsDefault = {
            shareurl: `${window.location.origin}${window.location.pathname}`,
            title: '',
            desc: '',
            thumb: '',
            documentId: '',
            type: '',
        };
        let paramsValue = {
            ...paramsDefault,
            ...params,
            thumb: params.thumbnail, // ios
            thumbnail: params.thumbnail, // android
            shareurl: appQueryUrl,
        };

        paramsValue = JSON.stringify(paramsValue);

        window.grounds.newShare(paramsValue);
    }
};
// 客户端获取状态栏高度
export const getStatusBarHeight = () => {
    if (!window.grounds || !window.grounds.getStatusBarHeight) {
        return 0;
    }

    const ratio = isIOS() ? 1 : window.devicePixelRatio;

    return window.grounds.getStatusBarHeight() / ratio;
};

// 曝光信息埋点数据上报
export const senPageInfoStatistics = (pinfoArray = []) => {
    if (isClient) {
        pinfoArray.forEach(pinfo => {
            Grounds.expose({
                behavior: 'pageinfo',
                environment: 'client',
                ...pinfo,
            });

            // pageStatistics([
            //     {
            //         behavior: 'pageinfo',
            //         environment: 'client',
            //         ...pinfo,
            //     },
            // ]);
        });
    }
};

// 端内跳转
export const groundsDispatch = ({ to, type }) => {
    // to:地址, type：默认web
    let dispatchUrl = to;
    const dispatchType = type;

    // setAppQuery:端内URL声明（如沉浸式?immersion=true）
    if (dispatchType === 'web') {
        dispatchUrl = setAppQuery(dispatchUrl);
    }

    window.grounds.dispatch(dispatchType, dispatchUrl);
};

export const getGv = () => {
    return window?.grounds?.getDeviceInfo().getGv();
};

export const getAv = () => {
    return window?.grounds?.getDeviceInfo().getAv();
};

export const getGuid = () => {
    return window?.grounds?.getUserInfo()?.getGuid();
};

export const getDeviceId = () => {
    return window?.grounds?.getDeviceInfo()?.getDeviceId();
};

export const getProid = () => {
    return window?.grounds?.getDeviceInfo()?.getProid();
};

export const getOs = () => {
    return window?.grounds?.getDeviceInfo()?.getOs();
};

export const getDf = () => {
    return window?.grounds?.getDeviceInfo()?.getDf();
};

export const getVt = () => {
    return window?.grounds?.getDeviceInfo()?.getVt();
};

export const getScreen = () => {
    return window?.grounds?.getDeviceInfo()?.getScreen();
};

export const getPublishid = () => {
    return window?.grounds?.getDeviceInfo()?.getPublishid();
};

export const getToken = () => {
    return window?.grounds?.getUserInfo()?.getToken();
};

export const getClientParams = () => {
    return {
        gv: getGv(),
        av: getAv(),
        uid: getGuid(),
        deviceid: getDeviceId(),
        proid: getProid(),
        os: getOs(),
        df: getDf(),
        vt: getVt(),
        screen: getScreen(),
        publishid: getPublishid(),
        token: getToken(),
    };
};
// 客户端参数测试专用
export const getClientParamsTest = () => {
    return {
        gv: '7.42.0',
        av: '0',
        uid: 'bd175e924cf84146810bf2986aa7bd33',
        proid: 'ifengnews',
        os: 'ios_14.0.1',
        df: 'iPhone8%2C2',
        vt: '5',
        screen: '1242x2208',
        publishid: '4002',
        uid2: 'bd175e924cf84146810bf2986aa7bd33',
        token: 'D61C704B67FFAA02033381D4DBF8CAD2',
        sn: '151661cdaae629bfbae7a45dd2a08985',
        st: '16473367321780',
        nw: 'wifi',
        loginid: '4000000087236570625',
    };
};
//  测试用
export const getClientParamsFromUrl = () => {
    return {
        gv: getSearchParam('gv') || getGv(),
        av: getGv(),
        uid: getSearchParam('uid'),
        deviceid: getSearchParam('deviceid') || getDeviceId(),
        proid: getSearchParam('proid'),
        os: getSearchParam('os'),
        df: getSearchParam('df'),
        vt: getSearchParam('vt'),
        publishid: getSearchParam('publishid'),
        nw: getSearchParam('nw'),
        loginid: getSearchParam('loginid'),
        hw: getSearchParam('hw'),
        ps: getSearchParam('ps') || 1,
        es: getSearchParam('es') || 1,
        uid2: getSearchParam('uid2'),
        st: getSearchParam('st'),
        sn: getSearchParam('sn'),
    };
};
const getUserInfo = window.grounds?.getUserInfo && window.grounds.getUserInfo();
// 获取用户头像
const getUserImage = () => {
    return getUserInfo?.getUserImage && window.grounds.getUserInfo().getUserImage();
};
// 获取用户昵称
const getNickname = () => {
    return getUserInfo?.getNickname && window.grounds.getUserInfo().getNickname();
};

const getPhoneNum = () => {
    return getUserInfo?.getPhoneNum && window.grounds.getUserInfo().getPhoneNum();
};

export const getUserInfoApi = {
    getUserImage, // 获取用户头像
    getNickname, // 获取用户昵称
    getToken, // 获取用户token
    getGuid, // 获取用户uid
    getPhoneNum,
};

export const moblieLogin = () => {
    try {
        // 有没有实名，有代表已经绑定了手机号
        if (!getUserInfoApi.getPhoneNum()) {
            // 有没有登录，有代表已经登录但没有绑定
            if (getUserInfoApi.getGuid()) {
                window.grounds.userBind();
            } else {
                userLogin();
            }

            return false;
        }

        return true;
    } catch (e) {
        console.log(e);
    }
};

// 监听页面离开
export const setPageNoActiveListener = callback => {
    // 安卓 webview 无法监听 visibilitychange 事件
    const isAndroid = /android/i.test(window.Grounds?.getDeviceInfo && window.Grounds.getDeviceInfo().getOs());

    if (window.grounds && isAndroid) {
        // window.grounds.on('active', 'historyTask_reGetData');
        window.grounds.on('onExit', 'historyTask_reGetData');
        window.historyTask_reGetData = () => callback();
    } else {
        document.addEventListener('visibilitychange', e => {
            if (document.visibilityState === 'hidden') {
                callback();
            }
        });
    }
};

// 禁止默认收拾区域，三个参数分别代表左上顶点纵坐标，左下顶点纵坐标， 屏幕高度
export const setH5PageTouchArea = (top = 0, bottom, height) => {
    try {
        // eslint-disable-next-line no-unused-expressions
        window.grounds?.setH5PageTouchArea && window.grounds.setH5PageTouchArea(top, bottom, height);
    } catch (e) {
        console.log(e);
    }
};

export const setNoSlideArea = area => {
    try {
        const data = JSON.stringify({
            area,
            totalHeight: window.innerHeight,
        });

        // eslint-disable-next-line no-unused-expressions
        window?.grounds?.setNoSlideArea && window?.grounds.setNoSlideArea(data);
    } catch (e) {
        console.log(e);
    }
};
/*
方法：window.grounds.openInput(options, callback);
options:
{
    value(string):打开输入框时，传入的文字
    placeholder(string):输入框的提示文字
    additional(enum):["photo","album","emoji", "gif", "audio"] 相机、相册、表情、动图、音频输入
    maxSize(number):最大输入文字长度
    callback(data):点击输入框，成功（文字不超出最大值，图片上传成功），客户端会回调该函数，并返回值。
    text(string):其中，emoji和gif都会以ubb的形式插入到text中
    image(string):上传的图片地址(图片只能上传一张。)
}
*/
// 端内原生评论
export const showInput = ({ replyName, callback }) => {
    const maxSize = 200;
    const config = {
        placeholder: replyName ? `回复${replyName}` : '请输入友善的评论',
        maxSize,
        limit: maxSize,
        additional: ['photo', 'album', 'emoji', 'gif', 'audio'],
    };

    if (isGrounds) {
        // 用户登陆
        if (userIsLogin()) {
            if (window.grounds.openInput || window.grounds.input) {
                // 声明回调（挂载window）方便使用
                const groundsCallbackName = 'inputFromClient';

                window[groundsCallbackName] = data => {
                    if (data && callback) {
                        callback(data);
                    }
                };

                if (window.grounds.openInput) {
                    window.grounds.openInput(JSON.stringify(config), groundsCallbackName);
                } else {
                    window.grounds.input(JSON.stringify(config), groundsCallbackName);
                }
            } else {
                // 先不考虑低版本客户端和端外的输入框
                // customModal(Input, { callback, config });
            }
        } else {
            userLogin();
        }
    } else {
        // 端外不会出现回复评论功能
    }
};

// 获取收藏状态
export const isCollected = callback => {};

// 收藏
/*
documentId, //  {string} 剧集id
id, // {string} 剧集id
subtype, // {string} 收藏分类 juji
title, //  {string} 剧集标题
thumbnail,  // {string} 缩略图
links : [{ // 跳转 {array->object}
    type, // {string} 跳转类型
    url // {string} 跳转协议
}],
*/
export const setCollect = ({ documentId, id, subtype, title, thumbnail, links: [{ type, url }] }, callback) => {
    const config = {
        documentId: '', //  {string} 剧集id
        id: '', // {string} 剧集id
        subtype: '', // {string} 收藏分类 juji
        title: '', //  {string} 剧集标题
        thumbnail: '', // {string} 缩略图
        links: [
            {
                // 跳转 {array->object}
                type: '', // {string} 跳转类型
                url: '', // {string} 跳转协议
            },
        ],
    };
    // 声明回调（挂载window）方便使用
    const groundsCallbackName = 'collectClient';

    window[groundsCallbackName] = data => {
        if (data && callback) {
            callback(data);
        }
    };

    if (window.grounds.collect) {
        window.grounds.collect(JSON.stringify(config), groundsCallbackName);
    }
};
